module.exports = __webpack_public_path__ + "img/tongue-twister-sprite-male.5dd3c160.png";